import { render, staticRenderFns } from "./GrocerSettings.vue?vue&type=template&id=57973dfc&scoped=true"
import script from "./GrocerSettings.vue?vue&type=script&lang=js"
export * from "./GrocerSettings.vue?vue&type=script&lang=js"
import style0 from "./GrocerSettings.vue?vue&type=style&index=0&id=57973dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57973dfc",
  null
  
)

export default component.exports